import React from 'react';
import Navbar from '../components/Navbar';

const ComingSoon = () => {
  return (
    <div className="min-h-screen font-sans" style={{ backgroundColor: '#0F2240' }}>
      <Navbar />

      {/* Radial glow */}
      <div
        className="fixed inset-0 pointer-events-none"
        aria-hidden="true"
        style={{ background: 'radial-gradient(ellipse 70% 55% at 50% 100%, rgba(197,145,50,0.12) 0%, transparent 65%)' }}
      />

      <main id="main-content" className="relative z-10 min-h-screen flex flex-col items-center justify-center px-6 text-center">

        {/* Solid navy plate — matches the page background exactly, so it's a
            visually invisible change that gives the text below a decidable,
            non-gradient surface instead of the ambient radial glow. */}
        <div className="max-w-2xl mx-auto py-6 bg-[#0F2240] flex flex-col items-center">

        {/* Gold pill */}
        <div className="inline-flex items-center gap-2.5 px-4 py-2 rounded-full border border-school-gold/25 bg-school-gold/8 text-school-gold font-semibold text-xs tracking-[0.18em] uppercase mb-10">
          <span className="relative flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-school-gold opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-school-gold" />
          </span>
          Page Coming Soon
        </div>

        {/* Heading */}
        <h1
          className="font-heading font-bold text-white tracking-tighter leading-[0.9] mb-6"
          style={{ fontSize: 'clamp(3rem, 8vw, 7rem)' }}
        >
          We're still
          <br />
          <span className="text-school-gold italic font-light">building this.</span>
        </h1>

        <p
          className="text-white/70 font-light leading-relaxed mb-12"
          style={{ fontSize: 'clamp(1rem, 2vw, 1.2rem)', maxWidth: '36rem' }}
        >
          This page is currently under construction. In the meantime, you can explore what's already available or head back to the homepage.
        </p>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row items-center gap-4">
          <a
            href="/"
            className="flex items-center gap-3 bg-school-gold text-school-blue px-8 py-4 rounded-full font-bold text-sm hover:bg-white transition-colors shadow-[0_0_40px_-8px_rgba(197,145,50,0.45)]"
          >
            Back to Homepage
          </a>
          <a
            href="/contact"
            className="flex items-center gap-3 bg-white/8 text-white px-8 py-4 rounded-full font-bold text-sm border border-white/12 hover:bg-white/15 transition-colors"
          >
            Contact Us
          </a>
        </div>

        {/* Divider */}
        <div className="mt-24 w-px h-16 bg-white/10 mx-auto" />
        {/* text-white/50 (was /20, 1.89:1) meets 4.5:1 on the navy background */}
        <p className="mt-6 text-white/50 text-xs tracking-widest uppercase">PS 85 · The Great Expectations School</p>
        </div>
      </main>
    </div>
  );
};

export default ComingSoon;
